import { FormGroup } from "../../components/form";
import * as Yup from "yup";

const validHeaders = [
  "NQAITS ID",
  "Account Name",
  "Parent Account: NQAITS ID",
  "Parent Account: Account Name",
  "Funding Status",
  "Status",
  "Region",
  "Area Name",
  "LGA",
  "Program Model",
  "EYM Managed Service",
  "Parent Account: Category",
  "Parent Account: Category Type",
];

const validateCSVHeaders = async (file: any) => {
  return new Promise<boolean>((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      let res = true;
      const text = (event.target?.result ?? "") as string;
      const rows = text.split("\n").map((row) => row.trim());
      const headers = rows[0]?.split(",").map((header) => header.trim());

      if (!headers || headers.length !== validHeaders.length) {
        res = false;
      } else {
        for (let i = 0; i < validHeaders.length; i++) {
          const header = headers[i].replace(/"/g, "");
          if (header !== validHeaders[i]) {
            res = false;
          }
        }
      }

      resolve(res);
    };
    reader.readAsText(file.file);
  });
};

export const referenceDataManagementForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "fileType",
      fieldType: "radio",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: ["Approved Kindergartens"],
      },
      label: "File Type",
    },
    {
      type: "field",
      key: "referenceDataManagementFile",
      fieldType: "file",
      label: "Reference File",
      validation: Yup.object({
        files: Yup.array()
          .min(1, "Please upload a file")
          .test("fileSize", "File uploaded cannot exceed 10MB in size", (files) => !files || files.length === 0 || files[0].size <= 10 * 1024 * 1024)
          .test("fileType", "Please upload a valid csv file", async (files) => {
            if (!files || files.length === 0) return true;
            const res = await validateCSVHeaders(files[0]);
            return res;
          }),
      }),
      props: {
        container: "referencedata",
        multi: false,
        extensions: ["csv"],
      },
    },

    {
      type: "field",
      key: "description",
      fieldType: "input",
      label: "Description",

      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader mt-5",
      },
      label: "File format",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
        Body: () => (
          <>
            {" "}
            <div className="flex flex-row mt-3">
              <h3 className="mt-0 mr-5">Approved Kindergartens</h3>{" "}
              <span>
                {" "}
                NQAITS ID, Account Name, Parent Account: NQAITS ID, Parent Account: Account Name, Funding Status, Status, Region, Area Name, LGA,
                Program Model, EYM Managed Service, Parent Account: Category, Parent Account: Category Type
              </span>
            </div>
          </>
        ),
      },
    },
  ],
};
